import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ActivateUserApiResultVo} from '../../common/shared/api/nicolas/vo/ActivateUserApiResultVo.interface';

/**
 * 사용자 활성화
 *
 * Origin: pageNicolasApi.activateUser
 * API: POST /auth/v1/app/activate_user
 */
export async function postAuthAppActivateUser(
  authParams?: {
    accessToken?: string;
    appUserId?: number;
  },
  options?: FetcherOptions
): Promise<ActivateUserApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/auth/v1/app/activate_user',
    {
      method: 'POST',
      data: authParams
        ? {
            app_user_id: authParams.appUserId,
            access_token: authParams.accessToken,
          }
        : undefined,
    },
    options
  );
  return response.data;
}
